module.exports = "/_next/static/images/sa-8f3e4e416935a439635ab7fceeefd641.svg";